import React from "react";

function Info() {
  return (
    <div className="footer__info">
      <p>© 2019 MYANT. ALL RIGHTS RESERVED</p>
      <p>Made By Gogi Loloyan</p>
    </div>
  );
}

export default Info;
